<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import { onBeforeUnmount, onMounted, ref } from "vue";

const currentMessage = ref<string | undefined>();

const onMessage = (event: Event) => {
  const { message } = (event as CustomEvent).detail;
  currentMessage.value = message;

  const timeout = setTimeout(() => {
    clearTimeout(timeout);
    currentMessage.value = undefined;
  }, 5000);
};

const closeMessage = () => {
  currentMessage.value = undefined;
};

onMounted(() => {
  document.addEventListener("custom-notification", onMessage);
});

onBeforeUnmount(() => {
  document.removeEventListener("custom-notification", onMessage);
});
</script>

<script lang="ts">
export const notify = (message: string) => {
  document.dispatchEvent(
    new CustomEvent("custom-notification", { detail: { message } }),
  );
};
</script>

<template>
  <div class="fixed left-0 bottom-5 w-full flex justify-center py-1">
    <button
      v-if="currentMessage"
      type="button"
      class="py-3 px-4 rounded-full flex gap-3 items-center hover:scale-105 transition-transform animate-in fade-in duration-500 bg-neutral900 text-white"
      @click="closeMessage"
    >
      <SVG icon="fas-check" height="1.5rem" width="1.5rem" />
      <div class="b300">{{ currentMessage }}</div>
    </button>
  </div>
</template>
